export default {
  agenda: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/schedule/resources/props.js